var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333374 2.00002C0.333374 1.6464 0.47385 1.30726 0.723899 1.05721C0.973947 0.807163 1.31309 0.666687 1.66671 0.666687H20.3334C20.687 0.666687 21.0261 0.807163 21.2762 1.05721C21.5262 1.30726 21.6667 1.6464 21.6667 2.00002C21.6667 2.35364 21.5262 2.69278 21.2762 2.94283C21.0261 3.19288 20.687 3.33335 20.3334 3.33335H1.66671C1.31309 3.33335 0.973947 3.19288 0.723899 2.94283C0.47385 2.69278 0.333374 2.35364 0.333374 2.00002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.333374 10C0.333374 9.6464 0.47385 9.30726 0.723899 9.05721C0.973947 8.80716 1.31309 8.66669 1.66671 8.66669H12.3334C12.687 8.66669 13.0261 8.80716 13.2762 9.05721C13.5262 9.30726 13.6667 9.6464 13.6667 10C13.6667 10.3536 13.5262 10.6928 13.2762 10.9428C13.0261 11.1929 12.687 11.3334 12.3334 11.3334H1.66671C1.31309 11.3334 0.973947 11.1929 0.723899 10.9428C0.47385 10.6928 0.333374 10.3536 0.333374 10Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66671 16.6667C1.31309 16.6667 0.973947 16.8072 0.723899 17.0572C0.47385 17.3073 0.333374 17.6464 0.333374 18C0.333374 18.3536 0.47385 18.6928 0.723899 18.9428C0.973947 19.1929 1.31309 19.3334 1.66671 19.3334H20.3334C20.687 19.3334 21.0261 19.1929 21.2762 18.9428C21.5262 18.6928 21.6667 18.3536 21.6667 18C21.6667 17.6464 21.5262 17.3073 21.2762 17.0572C21.0261 16.8072 20.687 16.6667 20.3334 16.6667H1.66671Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerIcon);
export default __webpack_public_path__ + "static/media/burger-icon.25d2263949d3155aae0434eebeb5c70f.svg";
export { ForwardRef as ReactComponent };